var map = {
	"./logo-ADELAIDE.svg": "5Af8",
	"./logo-BRISBANE-LIONS.svg": "xP52",
	"./logo-CARLTON.svg": "2MWK",
	"./logo-COLLINGWOOD.svg": "pkpY",
	"./logo-ESSENDON.svg": "MPyh",
	"./logo-FREMANTLE.svg": "QPIA",
	"./logo-GEELONG.svg": "nIFj",
	"./logo-GOLD-COAST.svg": "J2sO",
	"./logo-GWS-GIANTS.svg": "DCkw",
	"./logo-HAWTHORN.svg": "bHb/",
	"./logo-MELBOURNE.svg": "HGa0",
	"./logo-NORTH-MELBOURNE.svg": "BTMN",
	"./logo-PORT-ADELAIDE.svg": "1VBy",
	"./logo-RICHMOND.svg": "v1+c",
	"./logo-ST-KILDA.svg": "byaZ",
	"./logo-SYDNEY.svg": "4pH4",
	"./logo-WEST-COAST.svg": "6cKl",
	"./logo-WESTERN-BULLDOGS.svg": "OeO9"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Fy8w";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/logo\-.*\.svg$
// module id = Fy8w
// module chunks = 1